import { get as _get } from "lodash";
import { Avatar } from "@mui/material";

/**
 * Token logo; a missing or broken image falls back to the first letter of the symbol
 */
const TokenLogo = ({ token, size = 30, sx = {} }) => {
  const symbol = _get(token, "symbol", "");
  return (
    <Avatar
      src={_get(token, "logoURI", "") || undefined}
      alt={symbol ? `${symbol} logo` : "token logo"}
      sx={{ width: size, height: size, fontSize: size * 0.45, bgcolor: "secondary.main", color: "text.main", ...sx }}
    >
      {symbol.charAt(0).toUpperCase() || "?"}
    </Avatar>
  );
};

export default TokenLogo;
